import React, { useState, useRef, useEffect, useMemo } from "react";
import InnoIcons from "@InnoIcons/";
import SC from "./style";

const MoreFilterDropdown = ({
  label,
  selectedIds = [], // controlled by parent
  onSelectionChange = () => {},
  onOpenRelatedDropdown = () => {},
  filters = {}, // pass filters to detect filled dropdowns
  options,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef();

  // Options with related dropdown keys
  // const options = [
  //   { id: "1", label: "Original File Name", related: "TextFilterDropdown" },
  //   { id: "2", label: "Updated By", related: "UpdatedByTextFilterDropdown" },
  //   { id: "3", label: "Revision", related: "RevisionFilterDropdown" },
  //   { id: "4", label: "Updated Date", related: "CreatedOnDropdown" },
  // ];

  // Auto-check dropdowns that already have values
  const derivedSelectedIds = useMemo(() => {
    const ids = [...selectedIds];

    if (filters?.fileName?.value && !ids.includes("1")) ids.push("1");
    if (filters?.lastUpdateBy?.selectedIds?.length > 0 && !ids.includes("2"))
      ids.push("2");
    if (filters?.revision?.value && !ids.includes("3")) ids.push("3");
    if (filters?.lastUpdate && !ids.includes("4")) ids.push("4");

    return ids;
  }, [selectedIds, filters]);

  const filteredOptions = useMemo(() => {
    const lowerSearch = searchTerm.toLowerCase();
    return options.filter((option) =>
      option.label.toLowerCase().includes(lowerSearch)
    );
  }, [options, searchTerm]);

  const handleOptionClick = (option) => {
    const isSelected = derivedSelectedIds.includes(option.id);
    const updatedIds = isSelected
      ? derivedSelectedIds.filter((id) => id !== option.id)
      : [...derivedSelectedIds, option.id];

    onSelectionChange(updatedIds);

    // Update related dropdowns
    const selectedOptions = options.filter((opt) =>
      updatedIds.includes(opt.id)
    );
    onOpenRelatedDropdown(selectedOptions.map((opt) => opt.related));
  };

  const handleClearAll = () => {
    onSelectionChange([]);
    onOpenRelatedDropdown([]);
  };

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <SC.DropdownContainer ref={dropdownRef}>
      <SC.DropdownButton
        isOpen={isOpen}
        isActive={derivedSelectedIds.length > 0} // highlight if any active
        onClick={() => setIsOpen(!isOpen)}
      >
        {derivedSelectedIds.length > 0
          ? `${label}: ${derivedSelectedIds.length} selected`
          : label}
        <SC.ChevronIcon
          isOpen={isOpen}
          isActive={derivedSelectedIds.length > 0}
        />
      </SC.DropdownButton>

      <SC.DropdownMenu isOpen={isOpen}>
        <SC.SearchContainer>
          <SC.SearchIcon />
          <SC.SearchInput
            type="text"
            placeholder="Search More Filters"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </SC.SearchContainer>

        <SC.OptionsList>
          {filteredOptions.map((option) => (
            <SC.OptionItem key={option.id}>
              <SC.Checkbox
                type="checkbox"
                checked={derivedSelectedIds.includes(option.id)}
                onChange={() => handleOptionClick(option)}
                style={{ marginRight: "8px" }}
              />
              {option.label}
            </SC.OptionItem>
          ))}
        </SC.OptionsList>

        <SC.DropdownFooter>
          <SC.ClearAllButton onClick={handleClearAll}>
            Clear Selection
          </SC.ClearAllButton>
        </SC.DropdownFooter>
      </SC.DropdownMenu>
    </SC.DropdownContainer>
  );
};

export default MoreFilterDropdown;
